module.exports = __webpack_public_path__ + "img/banner.6b918c00.jpg";